// Environment detection by hostname — zero build config, since prod and UAT
// are separate deploys on distinct subdomains.

export type AppEnv = 'production' | 'uat' | 'local'

export function detectEnv(): AppEnv {
  if (typeof window === 'undefined') return 'production'
  const host = window.location.hostname
  if (host.startsWith('uat.')) return 'uat'
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) return 'local'
  return 'production'
}

// Browser-tab title prefix so UAT/local tabs are distinguishable at a glance in
// the tab switcher / tab list (production is unprefixed).
export function envTitlePrefix(): string {
  const env = detectEnv()
  if (env === 'uat') return 'UAT · '
  if (env === 'local') return 'DEV · '
  return ''
}
